import { render, staticRenderFns } from "./r-bundle-settings-panel.vue?vue&type=template&id=5bf48d3a"
import script from "./r-bundle-settings-panel.vue?vue&type=script&lang=js"
export * from "./r-bundle-settings-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf48d3a')) {
      api.createRecord('5bf48d3a', component.options)
    } else {
      api.reload('5bf48d3a', component.options)
    }
    module.hot.accept("./r-bundle-settings-panel.vue?vue&type=template&id=5bf48d3a", function () {
      api.rerender('5bf48d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-core/r-bundle-settings-panel.vue"
export default component.exports